import type { App } from 'vue'
import { acceptInvitationsGuard } from './guards/accept'
import { invitationGuard } from './guards/invitation'

export * from './guards/accept'
export * from './store'

export const createTeam = () => ({
  install: (app: App) => {
    const router = app.getRouter()
    router.beforeEach(acceptInvitationsGuard)

    router.addRoute('settings', {
      path: 'team',
      name: 'settings-team',
      meta: { head: { titleKey: 'team.tab' } },
      component: () => import('./components/TeamPanel.vue')
    })

    router.addRoute({
      path: '/invitations/:token',
      name: 'invitation',
      // Signing in first is what makes the address authoritative; `returnUrl` carries the token back.
      beforeEnter: invitationGuard,
      component: () => import('./pages/InvitationPage.vue')
    })
  }
})
